import { object, string } from "zod/v4";

export const ConfirmDiscountBubble = object({ discountCode: string() });
